import { render } from "./DemographicRoleDistributionCard.vue?vue&type=template&id=be998cb2&scoped=true"
import script from "./DemographicRoleDistributionCard.vue?vue&type=script&lang=js"
export * from "./DemographicRoleDistributionCard.vue?vue&type=script&lang=js"

import "./DemographicRoleDistributionCard.vue?vue&type=style&index=0&id=be998cb2&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be998cb2"]])

export default __exports__